<template>
    <div>
        <!-- Page header -->
        <div class="page-header page-header-dark">

            <!-- Górny pasek z logo i akcjami użytkownika -->
            <TopBar/>

        </div>
        <!-- /page header -->
    </div>
</template>

<script>
    import TopBar from './TopBar';


    export default {
        name: "HeaderBody",
        components: {TopBar},
    }
</script>

<style scoped>
    .affix{
       z-index: 10000;
        width: 100%;
        top: 0!important;
    }
</style>